module.exports = __webpack_public_path__ + "img/Group 607.ec6ea015.png";